import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Button, Dimmer, Dropdown, Loader, Modal} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';
import {mapListToDropdownList} from '../../../../common/components/commercialTable/utils';

const {
  setSelectedVehicleCombo,
  updateVehicleCombo,
} = Actions;

const UpdateComboModal = ({openComboModal, setOpenComboModal}) => {
  const dispatch = useDispatch();
  const [combosList, setCombosList] = useState([]);
  const {
    combos,
    loadingCombos,
    loadingUpdateCombos,
    selectedVehicleCombo,
  } = useSelector((state) => state.priorizationDates);

  useEffect(() => {
    setCombosList(mapListToDropdownList(
      combos,
      {
        'keys': ['code'],
        'values': ['code'],
        'texts': ['code', 'description'],
      },
      false, '/'));
  }, [combos]);

  const handleChangeCombo = (value) => {
    dispatch(setSelectedVehicleCombo({
      ...selectedVehicleCombo,
      'comboCode': value,
    }));
  };

  const handleUpdateCombo = () => {
    dispatch(updateVehicleCombo({'data': selectedVehicleCombo}));
    dispatch(setSelectedVehicleCombo(null));
  };

  const handleClose = () => {
    setOpenComboModal(false);
    dispatch(setSelectedVehicleCombo(null));
  };
  return (
    <Modal
      size={'mini'}
      open={openComboModal}
    >
      <Dimmer active={loadingUpdateCombos} inverted>
        <Loader />
      </Dimmer>
      <Modal.Header>Modificar Combo</Modal.Header>
      <Modal.Content>
        <label><h4>{selectedVehicleCombo?.chassis}</h4></label>
        <br/>
        <Dropdown
          loading={loadingCombos}
          placeholder='Seleccione el combo deseado'
          value={selectedVehicleCombo?.comboCode}
          fluid
          selection
          options={combosList}
          onChange={(e, {value}) => handleChangeCombo(value)}
        />
      </Modal.Content>
      <Modal.Actions>
        <Button
          basic
          onClick={handleClose}
        >
          Cancelar
        </Button>
        <Button
          primary
          onClick={handleUpdateCombo}
        >
          Actualizar
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default UpdateComboModal;
